export function DotIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle opacity="0.2" cx="8" cy="8" r="7" fill="#101828" />
      <circle opacity="0.6" cx="8" cy="8" r="2" fill="#101828" />
    </svg>
  );
}

DotIcon.displayName = 'DotIcon';
